import { useMemo } from "react";
import { useCanvasStore, type AwaitingInput } from "@/stores/canvas-store";
import { useCompanionStore } from "@/stores/companion-store";
import {
  oldestTaskQuestion,
  questionTaskIds,
  runningTaskIds,
  type TaskSignals,
} from "./task-state";

/**
 * The board-wide sets behind the state dots. The selectors return strings,
 * so a board re-renders only when a task's question or run state changes.
 */
export function useTaskSignals(): TaskSignals {
  const questionKey = useCanvasStore((state) =>
    questionTaskIds(state.awaitingInputs).join(" "),
  );
  const runningKey = useCompanionStore((state) =>
    runningTaskIds(state.executions).join(" "),
  );
  return useMemo(
    () => ({
      questionTaskIds: new Set(questionKey ? questionKey.split(" ") : []),
      runningTaskIds: new Set(runningKey ? runningKey.split(" ") : []),
    }),
    [questionKey, runningKey],
  );
}

/** The oldest question an agent waits on for this task. */
export function useTaskQuestion(taskId: string): AwaitingInput | null {
  const awaitingInputs = useCanvasStore((state) => state.awaitingInputs);
  return useMemo(
    () => oldestTaskQuestion(awaitingInputs, taskId),
    [awaitingInputs, taskId],
  );
}
